import * as types from "../constants/ActionTypes";

export const replyIdToSearch = (state = null, action) => {
  switch (action.type) {
    case types.HISTORY:
      return action.replyId || null;
    case types.CLEAN_REPLY_ID_TO_SEARCH:
      return null;
    default:
      return state;
  }
};
